//DATA
export const NAVLINKS_SAVED = 'NAVLINKS_SAVED';

//UI
export const EDIT_LINK = 'EDIT_LINK';
export const SAVING_NAVLINKS = 'SAVING_NAVLINKS';